import { NgModule } from '@angular/core';
import { InAppBrowser } from '@laurentgoudet/ionic-native-in-app-browser/ngx';

@NgModule({
  providers: [InAppBrowser],
})
export class DepositsModule {}
